export default {"src":"/_next/static/media/meditation.colour.d8fdabb3.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};